<template>
  <div class="scoreTable">
    <span class="tip">作业详情</span>
    <div class="referBox">
      <!-- {{timeData}} -->
      <h4>{{timeData.startDate | timestampToTime}} 至 {{timeData.endDate | timestampToTime}}期间</h4>
      <div class="boxSubmit">
         <span>收到作业{{workReport.workCount}}次</span>
         <ul class="progressBar">
           <li>
             <span>排名前五： {{workReport.topFifthCount}}次</span>
             <div class="barBox">
               <span class="barLi bar1" :style ="{width: (workReport.topFifthCount / workReport.workCount ) * 100 + '%'}"></span>
             </div>
           </li>
            <li>
              <span>未提交：{{workReport.unSubmitCount}}次</span>
              <div class="barBox">
                <span class="barLi bar2" :style ="{width: (workReport.unSubmitCount / workReport.workCount ) * 100 + '%'}"></span>
              </div>
            </li>
            <li>
              <span>低于平均分：{{workReport.underAvgScoreCount}}次</span>
              <div class="barBox">
                <span class="barLi bar3" :style ="{width: (workReport.underAvgScoreCount / workReport.workCount ) * 100 + '%'}"></span>
              </div>
            </li>
            <li>
              <span>高于平均分：{{workReport.overAvgScoreCount}}次</span>
              <div class="barBox">
                <span class="barLi bar4" :style ="{width: (workReport.overAvgScoreCount / workReport.workCount ) * 100 + '%'}"></span>
              </div>
            </li>
         </ul>
      </div>
    </div>
    <table cellspacing='0'>
        <tr>
          <th>作业</th>
          <th>排名</th>
          <th>
            得分
          </th>
          <th>
            班级平均分
          </th>
          <th>
            总分
          </th>
        </tr>
    </table>
    <table class="chunkT" cellspacing='0' v-for="item in reportDetail.pageList">
        <tr v-for="(ritem, rindex) in item.contentList">
            <td class="dateT" :rowspan="item.contentList.length" v-if="rindex==0">{{item.sendDate}}</td>
            <td class="wName">
              {{ritem.resourceName}}
            </td>
            <td>
              {{ritem.ranking}}
            </td>
            <td>
              {{ritem.actualScore}}
            </td>
            <td>
              {{ritem.avgScore}}
            </td>
            <td>
              {{ritem.workScore}}
            </td>
        </tr>
    </table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage"
      :page-size="5" layout="total, prev, pager, next" :total="reportDetail.totalCount">
    </el-pagination>
  </div>
</template>
<script>
export default {
  props: ['reportDetail', 'workReport', 'timeData'],
  data() {
    return {
      currentPage: 1,
    }
  },
  created() {
    this.$nextTick(() => {
      // this.setSorcTable()
    })
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('setPage', val)
    },
    handleCurrentChange(val) {
      this.$emit('setPage', val)
    }
  }
};
</script>



// WEBPACK FOOTER //
// scoreTable.vue?247f637a